import { DateTime } from 'luxon';
import User from './User';
import { Work as KaizenOfferWork } from '@kaizenplatform/kaizen-offer-entity';
import Organization from './Organization';
import CreativeType from './CreativeType';

class Work extends KaizenOfferWork {
  constructor({
    id,
    user,
    organization,
    creativeType,
    offerName,
    thumbnailUrl,
    assetUrl,
    intent,
    createdAt,
    achievementName,
  }: Pick<
    KaizenOfferWork,
    | 'id'
    | 'user'
    | 'organization'
    | 'creativeType'
    | 'offerName'
    | 'thumbnailUrl'
    | 'assetUrl'
    | 'intent'
    | 'createdAt'
    | 'achievementName'
  >) {
    super({
      id,
      user,
      organization,
      creativeType,
      offerName,
      thumbnailUrl,
      assetUrl,
      intent,
      createdAt,
      achievementName,
    });
  }

  public static fromJSON = (value: any) => {
    const {
      id,
      user: _user,
      organization: _organization,
      creativeType: _creativeType,
      offerName,
      thumbnailUrl,
      assetUrl,
      intent,
      createdAt: _createdAt,
      achievementName,
    } = Object.assign({}, value);

    const createdAt = DateTime.fromISO(_createdAt);
    const user = User.fromJSON(_user);
    const organization = Organization.fromJSON(_organization);
    const creativeType = CreativeType.fromJSON(_creativeType);

    if (typeof id !== 'string') throw new TypeError('.id must be a string');
    if (typeof offerName !== 'string') throw new TypeError('.offerName must be a string');
    if (thumbnailUrl !== null && typeof thumbnailUrl !== 'string') {
      throw new TypeError('.thumbnailUrl must be a string');
    }
    if (typeof assetUrl !== 'string') throw new TypeError('.assetUrl must be a string');
    if (intent !== null && typeof intent !== 'string') {
      throw new TypeError('.intent must be a string');
    }
    if (typeof achievementName !== 'string') throw new TypeError('.achievementName must be a string');

    return new Work({
      id,
      user,
      organization,
      creativeType,
      offerName,
      thumbnailUrl,
      assetUrl,
      intent,
      createdAt,
      achievementName,
    });
  };
}

export type WorkId = string;

export default Work;
